"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const InputLoader_1 = __importDefault(require("../InputLoader/InputLoader"));
const Text_1 = require("../Text/Text");
const Button_style_1 = require("./Button.style");
const { primaryButton, buttonContentWrapper, primaryText, linkText, disabledButton, } = Button_style_1.styles;
function Button({ type = 'primary', text, isLoading = false, isDisabled = false, onClick, }) {
    const pressableStyle = (0, react_1.useMemo)(() => {
        const styles = [];
        if (type === 'primary') {
            styles.push(primaryButton);
        }
        if ((isLoading || isDisabled) && type !== 'link') {
            styles.push(disabledButton);
        }
        return styles;
    }, [isLoading, isDisabled, type]);
    const textStyle = (0, react_1.useMemo)(() => {
        const styles = [];
        if (type === 'primary') {
            styles.push(primaryText);
        }
        if (type === 'link') {
            styles.push(linkText);
        }
        return styles;
    }, [isLoading, isDisabled, type]);
    return (react_1.default.createElement(react_native_1.Pressable, { style: pressableStyle, onPress: onClick, disabled: isDisabled },
        react_1.default.createElement(react_native_1.View, { style: [buttonContentWrapper, { alignSelf: 'center' }] },
            isLoading && (react_1.default.createElement(InputLoader_1.default, { color: type === 'link' ? '#3db384' : '#fff' })),
            react_1.default.createElement(Text_1.Text, { style: textStyle }, text))));
}
exports.default = Button;
